import {
  LayersIcon,
  FileTextIcon,
  MessageSquareQuoteIcon,
  ListChecksIcon,
  RulerIcon,
  ClipboardListIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const kitContents: { icon: LucideIcon; title: string; description: string }[] = [
  {
    icon: LayersIcon,
    title: '6 Niveaux Complets',
    description: 'De Fondamentaux à Avancé II, une progression continue.',
  },
  {
    icon: FileTextIcon,
    title: '360 Pages de Contenu',
    description: 'Vocabulaire, repères visuels et script de coaching à chaque niveau.',
  },
  {
    icon: MessageSquareQuoteIcon,
    title: 'Guide Étape par Étape',
    description: 'Un Coach Script Box prêt à utiliser en cours, à chaque bloc.',
  },
  {
    icon: ListChecksIcon,
    title: '144 Exercices Classés',
    description: "Trois niveaux de difficulté (⭐/⭐⭐/⭐⭐⭐) par bloc d'entraînement.",
  },
  {
    icon: RulerIcon,
    title: 'Diagrammes Illustrés',
    description: 'Posture et alignement représentés clairement, prêts à consulter en cours.',
  },
  {
    icon: ClipboardListIcon,
    title: 'Séquences de Cours Complètes',
    description: 'Un cours entier déjà structuré à la fin de chaque niveau.',
  },
]
